/**
 * Wave 14 Agent TRIAL - Layer 3.
 *
 * Light-weight inline toast for a freshly-unlocked achievement. Hosts
 * subscribe to the ``wave14:milestone-unlocked`` window event with
 * detail = AchievementResult.
 */
import { useEffect, useState } from 'react'
import { TrackMilestoneResult } from '@/api/wave14Trial'

export function MilestoneToast() {
  const [toast, setToast] = useState<TrackMilestoneResult | null>(null)

  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<TrackMilestoneResult>
      if (!ce.detail || !ce.detail.newly_achieved) return
      setToast(ce.detail)
      const timer = window.setTimeout(() => setToast(null), 6000)
      return () => window.clearTimeout(timer)
    }
    window.addEventListener('wave14:milestone-unlocked', handler as EventListener)
    return () =>
      window.removeEventListener(
        'wave14:milestone-unlocked',
        handler as EventListener
      )
  }, [])

  if (!toast) return null

  return (
    <div
      data-testid="milestone-toast"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-emerald-600 text-white px-4 py-3 rounded-lg shadow-xl flex items-center gap-3"
    >
      <span className="text-2xl">🎉</span>
      <div>
        <div className="font-semibold">Milestone unlocked!</div>
        <div className="text-sm opacity-90">
          {toast.milestone_type.replace(/_/g, ' ')} -- trial extended by{' '}
          +{toast.extension_days_granted} days
        </div>
      </div>
      <button
        onClick={() => setToast(null)}
        className="opacity-80 hover:opacity-100"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  )
}

export function announceMilestone(result: TrackMilestoneResult) {
  window.dispatchEvent(
    new CustomEvent<TrackMilestoneResult>('wave14:milestone-unlocked', {
      detail: result,
    })
  )
}

export default MilestoneToast
